module.exports = __webpack_public_path__ + "static/media/website.6901fe55.png";